var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13C21.0523 13 21.5 12.5523 21.5 12C21.5 11.4477 21.0523 11 20.5 11L6.41406 11L11.0713 6.34278C11.4615 5.95224 11.4617 5.31915 11.0713 4.92872C10.6809 4.5383 10.0478 4.53849 9.65723 4.92872L3.29297 11.293C2.90244 11.6835 2.90244 12.3165 3.29297 12.707L9.65723 19.0713C10.0478 19.4615 10.6809 19.4617 11.0713 19.0713C11.4617 18.6809 11.4615 18.0478 11.0713 17.6572L6.41406 13L20.5 13Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOut);
export default __webpack_public_path__ + "static/media/arrow-out.3bcac9555a2179e6126f90b1c25f40d5.svg";
export { ForwardRef as ReactComponent };